export function renderHTML(): string {
  return /* html */ `
  <div class="jb-notification-wrapper-web-component">
    <slot></slot>
  </div>
  `;
}